import request from 'utils/request'
import { combineReducers } from 'redux'
import { isBlockConsent } from '../../Consent/utils/consentUtils'
import { selectRelevantVisits } from './visitUtils'
import { logSentryEvent, SENTRY_MESSAGES } from '../../../utils/sentry'

const SET_UPCOMING_VISITS = 'SET_UPCOMING_VISITS'

const setUpcomingVisits = (upcomingVisits) => {
  return {
    type: SET_UPCOMING_VISITS,
    upcomingVisits
  }
}

export const onFetchUpcomingVisits = (studyId, noLoader = false) => {
  return (dispatch) => {
    return dispatch(
      request({
        method: 'GET',
        url: `/control/studies/${studyId}/upcoming_visits/participants/me`,
        hasLoader: !noLoader,
        success: (json) => {
          const visits = json.upcoming_visits || []

          dispatch(
            setUpcomingVisits({
              pastVisits: [],
              upcomingVisits: visits
            })
          )
        }
      })
    )
  }
}

const _fetchSSVisits = (studyID, noLoader = false) => {
  return (dispatch) => {
    return dispatch(
      request({
        method: 'GET',
        url: `/control/studies/${studyID}/study_schedules_visits/participants/me`,
        success: (json) => {
          return Promise.resolve(json)
        },
        hasLoader: !noLoader,
        onFailLog: () => {
          logSentryEvent({
            message: SENTRY_MESSAGES.visitsTimelineFetchFailed,
            level: 'error',
            tags: {
              flow: 'visits',
              action: 'timeline_fetch_failed',
            },
          })
        },
      })
    )
  }
}

export const onFetchSSUpcomingVisits =
  (studyID) => async (dispatch, getState) => {
    const { consent, user } = getState()
    if (isBlockConsent(user, consent)) {
      // Stop everything. Do NOT fetch.
      return
    }
    return dispatch(_fetchSSVisits(studyID)).then((json) => {
      const ssVisitsArr = json.ss_visits_participant
      const adhocVisitsArr = json.ss_visits_participant_adhoc || []

      dispatch(
        setUpcomingVisits(
          selectRelevantVisits(ssVisitsArr, adhocVisitsArr)
        )
      )
    })
  }

const upcomingVisitsList = (
  state = { pastVisits: [], upcomingVisits: [] },
  action
) => {
  switch (action.type) {
    case SET_UPCOMING_VISITS:
      return action.upcomingVisits
    default:
      return state
  }
}

export const visitsActions = {
  onFetchUpcomingVisits
}

export default combineReducers({
  upcomingVisitsList
})
